import { type ReactNode, useCallback } from "react";
import "./ImportActionSelector.scss";
import RadioButton from "@/shared/components/generic/checkbox/RadioButton.tsx";
import { Size } from "@/shared/components/generic/UiEnums.ts";
import { useTranslation } from "react-i18next";
import type { Item } from "@/shared/components/generic/items.ts";
import type { ImportAction } from "@/pages/human-resources/time-management/components/schedule-import/model/ImportAction.ts";

interface Properties {
  action: ImportAction;
  onChange: (value: ImportAction) => void;
}

export default function ImportActionSelector(props: Properties): ReactNode {
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement.scheduleImportDialog.actions",
  });

  const handleActionChanged = useCallback(
    (item: Item, selected: boolean) => {
      if (!selected) return;
      if (item.key === "overwrite") {
        props.onChange("overwrite");
      } else {
        props.onChange("fillEmpty");
      }
    },
    [props],
  );

  return (
    <div className="import-action-selector">
      <div className="action-prompt">{t("prompt")}</div>
      <div className="actions-options">
        {(["fillEmpty", "overwrite"] as ImportAction[]).map((action) => (
          <RadioButton
            key={`${action}-${props.action}`}
            size={Size.SMALL}
            item={{ key: action, label: t(action) }}
            onChange={handleActionChanged}
            selected={props.action === action}
          />
        ))}
      </div>
    </div>
  );
}
